<div
  class="card border rounded-6 p-3 my-2 mx-1 h-100"
  [ngStyle]="{ cursor: seeBreakdownVisible ? 'pointer' : 'default' }"
  (click)="onCardClick()"
>
  <div
    class="d-flex w-100"
    [ngClass]="{
      'flex-column-reverse align-items-start': wide,
      'justify-content-between align-items-center': !wide
    }"
  >
    <div
      [ngClass]="{
        'fs-2 fw-bold p-3 ': true,
        'total-number': wide,
        'normal-number': !wide
      }"
    >
      {{ number | number }}
    </div>

    <div class="d-flex align-items-center p-3" *ngIf="!wide">
      <div
        class="d-flex align-items-center gap-2 fw-semibold"
        *ngIf="percentage !== undefined"
      >
        <span class="text-success">+{{ countIncrease }}</span>
        <span class="text-muted">|</span>
        <span>
          {{ percentage | number : "1.2-2" }}%
          <svg
            width="20"
            height="19"
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.0761719"
              y="0.869995"
              width="19.6742"
              height="18.13"
              rx="4"
              fill="#00A372"
            />
            <path
              d="M6.07617 8.70712L9.91329 4.87L13.7504 8.70712M9.91329 15V5.33045"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
      </div>
    </div>

    <div class="fw-semibold text-muted p-3" *ngIf="wide">
      {{ title | translate }}
    </div>
  </div>

  <div class="fw-semibold text-muted p-3" *ngIf="!wide">
    {{ title | translate }}
  </div>

  <ng-container *ngIf="hasNonZeroCategories; else placeholderBar">
    <div
      class="bar d-flex w-100 overflow-hidden rounded-pill my-2"
      [class.wide-bar]="wide"
      [class.normal-bar]="!wide"
      [ngClass]="{ 'py-2': wide, 'py-1': !wide }"
    >
      <div
        class="d-flex align-items-center justify-content-center text-white fw-semibold p-2"
        *ngFor="let cat of visibleCategories; let i = index"
        [ngStyle]="{
          width: wide || sameLenght ? widthPercentages[i] + '%' : adjustedPercentages[i] + '%',
          backgroundColor: cat.color || '#ccc'
        }"
      >
        {{ wide ? adjustedPercentages[i].toFixed(2) : adjustedPercentages[i] }}%
      </div>
    </div>
  </ng-container>

  <ng-template #placeholderBar>
    <div
      class="d-flex w-100 overflow-hidden rounded-pill my-2"
      [ngClass]="{ 'py-2': wide, 'py-1': !wide }"
      style="background-color: #e0e0e0; height: 24px"
    ></div>
  </ng-template>

  <div
    class="d-flex w-100 class card-legend-container"
    [ngClass]="{
      'flex-column-reverse align-items-center': wide,
      'justify-content-between': !wide
    }"
  >
    <div
      class="d-none d-lg-flex flex-nowrap"
      [ngClass]="{ 'gap-5 w-100 justify-content-center': wide }"
      *ngIf="categories && categories.length"
    >
      <div
        class="d-flex align-items-center p-3"
        [ngClass]="{ 'flex-column align-items-start': wide }"
        *ngFor="let cat of visibleLegendItems"
      >
        <div class="d-flex align-items-center gap-1">
          <span
            class="rounded-circle d-inline-block"
            style="width: 15px; height: 15px"
            [ngStyle]="{ backgroundColor: cat.color || '#ccc' }"
          ></span>
          <label class="text-muted mb-0 category-label" [ngClass]="{ 'less-space': visibleLegendItems.length >= 3 && !wide && title != 'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_STRUCTURE' }">{{
            cat.name | translate
          }}</label>
        </div>
        <strong class="fw-semibold ms-1">{{ cat.count | number }}</strong>
      </div>

      <div class="d-flex align-items-center" *ngIf="shouldShowEllipsis">
        <label class="mb-0"> ...</label>
      </div>
    </div>

    <div
      *ngIf="seeBreakdownVisible && !wide"
      class="fw-semibold text-nowrap ps-2 p-3 see-breakdown"
    >
      {{ "COMMON.SEE_BREAKDOWN" | translate }} >
    </div>
  </div>
</div>
